import { HistoryListProps } from "@husky-x/history-list";

export const HistoryMock: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'LA Jackson gründet die London Rubber Company und verkauft importierte Kondome und Zubehör für Herrenfriseure.',
		},
		{
			year: 1929,
			description: 'Die London Rubber Company (LRC) lässt die Marke „Durex“ registrieren',
		},
		{
			year: '1950er',
			description: 'Durex bringt sein erstes befeuchtetes Kondom auf den Markt',
		},
		{
			year: 1953,
			description: 'Durex ist die erste Marke, die ein elektronisches Testverfahren entwickelt und einsetzt',
		},
		{
			year: '1960er',
			description: 'Durex bringt das erste anatomisch geformte Kondom auf den Markt',
		},
		{
			year: '1970er',
			description: 'Durex ist die weltweit erste Kondommarke, die in vielen Ländern Werbung betreibt',
		},
		{
			year: '1990er',
			description: 'Durex ist die erste Kondommarke, die ein globales „Qualitätssiegel“ als Standard einführt',
		},
		{
			year: 1995,
			description: 'Durex bringt eine Reihe bunter und aromatisierter Kondome auf den Markt',
		},
		{
			year: 1996,
			description: 'Durex ist die erste Kondommarke, die eine Website einrichtet',
		},
		{
			year: 1997,
			description: 'Durex bringt latexfreie Kondome auf den Markt. Für das Produkt wird ein neues, nicht allergieauslösendes Material genutzt: Das von Durex entwickelte synthetische Polyurethan ist weicher und elastischer als Naturkautschuklatex.',
		},
		{
			year: 1998,
			description: 'Durex ist die erste Kondommarke, die eine Umfrage zum weltweiten sexuellen Wohlbefinden durchführt und veröffentlicht',
		},
		{
			year: 2001,
			description: 'Durex bringt Pleasuremax auf den Markt und ist somit die erste Kondommarke, die ein Kondom vermarktet, das zur Stimulation beider Partner sowohl gerippt als auch genoppt ist.',
		},
		{
			year: 2003,
			description: 'Durex bringt ein aufregendes Sortiment von Play Gleitgelen auf den Markt',
		},
		{
			year: 2005,
			description: 'Durex Network veröffentlicht die Berichte „Face of Global Sex“, die die Aspekte sexuellen Verhaltens erforschen und als Informationsquelle für Akademiker und Entscheidungsträger dienen sollen.',
		},
		{
			year: 2008,
			description: 'Um Safer Sex bei jungen Leuten zu fördern, ermutigt Durex Teens und Twens zwischen 16 und 24 Jahren dazu, ein einzigartiges Poster zur sexuellen Gesundheit zu entwerfen – ein Poster von Jugendlichen für Jugendliche.',
		},
		{
			year: 2009,
			description: 'Durex wird 80!',
		},
		{
			year: 2010,
			description: 'Durex unterstützt die Initiative „Condomize!“ des Bevölkerungsfonds der Vereinten Nationen bei der Welt-AIDS-Konferenz in Wien durch eine Spende von 220.000 Kondomen.',
		},
		{
			year: 2010,
			description: 'Durex wird von Reckitt Benckiser aufgekauft.'
		},
		{
			year: 2010,
			description: 'Durex bringt Performax Intense auf den Markt – ein Kondom, das für den gemeinsamen Höhepunkt entwickelt wurde. Dieses Kondom hat eine Innenbeschichtung mit 5% Benzocain und eine stimulierende Struktur, die zu längerem und intensiverem Sex verhelfen soll',
		},
		{
			year: 2019,
			description: 'Durex wird 90!.',
		},
	]
}

export const HistoryMockFr: HistoryListProps  = {
	data: [
		{
			year: 1915,
			description: 'Rajackson a rejoint la London Rubber Company pour vendre aux coiffeurs hommes des préservatifs importés et des accessoires.',
		},
		{
			year: 1929,
			description: 'La London Rubber Company (LRC) dépose la marque Durex ',
		},
		{
			year: 'Années 1950',
			description: 'Durex sort son premier préservatif lubrifié',
		},
		{
			year: 1953,
			description: 'Durex est la première marque à développer et à faire des tests électroniques',
		},
		{
			year: 'Années 1960',
			description: 'Durex lance le premier préservatif à forme anatomique',
		},
		{
			year: 'Années 1970',
			description: 'Durex est la première marque de préservatifs au monde à faire de la publicité dans de nombreux pays',
		},
		{
			year: 'Années 1990',
			description: 'Durex est la première marque de préservatifs à adopter un label de qualité mondial comme norme',
		},
		{
			year: 1995,
			description: 'Durex sort une gamme de préservatifs colorés et aromatisés',
		},
		{
			year: 1996,
			description: 'Durex est la première marque de préservatifs à lancer son site internet. Aujourd’hui nous avons 42 sites différents dans les pays où la marque est commercialisée',
		},
		{
			year: 1997,
			description: 'Durex sort des préservatifs sans latex. Une nouvelle matière non allergénique est utilisée pour le nouveau produit : le polyuréthane synthétique. Développé par Durex, il est plus doux et plus élastique que le caoutchouc naturel du latex',
		},
		{
			year: 1998,
			description: 'Durex est la première marque de préservatifs à conduire et publier une étude mondiale sur le bien-être sexuel',
		},
		{
			year: 2001,
			description: 'Durex présente Pleasuremax. Il fait de Durex la première marque à commercialiser un préservatif qui allie une texture perlée et nervurée',
		},
		{
			year: 2003,
			description: 'Durex lance une gamme confort et ludique de lubrifiants Play',
		},
		{
			year: 2005,
			description: 'Le réseau Durex lance ses rapports « Face of Global Sex » qui explorent les aspects des comportements sexuels et qui sont destinés à informer les universitaires et pouvoirs publiques',
		},
		{
			year: 2008,
			description: "Afin de promouvoir le sexe en toute sécurité pour les jeunes, Durex encourage des jeunes âgés de 16 à 24 ans à créer une affiche unique sur la santé sexuelle – un poster d'adolescents pour les adolescents",
		},
		{
			year: 2009,
			description: 'Durex a 80 ans !',
		},
		{
			year: 2010,
			description: 'Durex est racheté par Reckitt Benckiser',
		},
		{
			year: 2010,
			description: "Durex lance Performax Intense, un préservatif conçu pour atteindre l'orgasme simultanément. Avec 5 % de benzocaïne dans le revêtement intérieur et une structure stimulante, il aide à prolonger et intensifier les relations sexuelles"
		},
		{
			year: 2010,
			description: 'Clarification des boîtes de préservatifs Durex en ajoutant une codification visuelle permettant d’orienter le consommateur d’une manière claire vers le préservatif qui lui correspond le mieux : taille, largeur nominale, lubrification et matière',
		},
		{
			year: 2019,
			description: 'Durex a 90 ans !',
		},
	]
}